/**
 * Cart shipping estimate from shop.metafields.shipping_rules.config
 * (same rules engine as dmi-dashboard-shipping / checkout).
 */
(function (window) {
  function normalizeCountryCode(country) {
    if (!country) return 'NL';
    var s = String(country).toLowerCase().trim();
    if (s === 'nl' || s === 'nld' || s === 'netherlands') return 'NL';
    if (s === 'be' || s === 'bel' || s === 'belgium') return 'BE';
    if (s === 'de' || s === 'deu' || s === 'germany') return 'DE';
    return String(country).toUpperCase();
  }

  function parseShippingConfig(raw) {
    if (!raw) return null;
    if (typeof raw === 'string') {
      try {
        return JSON.parse(raw);
      } catch (e) {
        return null;
      }
    }
    if (typeof raw === 'object') return raw;
    return null;
  }

  function findZoneForCountry(config, destinationCountry) {
    var zones = (config && config.zones) || [];
    var explicit = zones.find(function (z) {
      return !z.restOfWorld && (z.countries || []).indexOf(destinationCountry) !== -1;
    });
    if (explicit) return explicit;

    var covered = {};
    zones.forEach(function (zone) {
      if (!zone.restOfWorld) {
        (zone.countries || []).forEach(function (code) {
          covered[code] = true;
        });
      }
    });
    if (!covered[destinationCountry]) {
      return zones.find(function (z) {
        return z.restOfWorld;
      }) || null;
    }
    return null;
  }

  function getTierPrice(tiers, subtotal) {
    if (!tiers || !tiers.length) return null;
    for (var i = 0; i < tiers.length; i++) {
      var tier = tiers[i];
      var min = tier.minSubtotal != null ? tier.minSubtotal : 0;
      var max = tier.maxSubtotal;
      var aboveMin = subtotal >= min;
      var belowMax = max == null || subtotal <= max;
      if (aboveMin && belowMax) return tier.price;
    }
    return null;
  }

  function normalizeTags(tags) {
    return (tags || []).map(function (t) {
      return String(t).toLowerCase();
    });
  }

  function normalizeEntityId(id) {
    if (id == null) return '';
    var str = String(id);
    var match = str.match(/(\d+)$/);
    return match ? match[1] : str;
  }

  function itemHasAnyTag(item, tags, tagsByProductId) {
    var productTags = normalizeTags(tagsByProductId[item.product_id] || tagsByProductId[String(item.product_id)]);
    return tags.some(function (t) {
      return productTags.indexOf(t.toLowerCase()) !== -1;
    });
  }

  function getConditionProductIds(conditions) {
    var fromProducts = (conditions.products || []).map(function (p) {
      return normalizeEntityId(p.id);
    });
    var legacy = (conditions.productIds || []).map(normalizeEntityId);
    return fromProducts.concat(legacy).filter(Boolean).filter(function (id, idx, arr) {
      return arr.indexOf(id) === idx;
    });
  }

  function getConditionCollectionIds(conditions) {
    var fromCollections = (conditions.collections || []).map(function (c) {
      return normalizeEntityId(c.id);
    });
    var legacy = (conditions.collectionIds || []).map(normalizeEntityId);
    return fromCollections.concat(legacy).filter(Boolean).filter(function (id, idx, arr) {
      return arr.indexOf(id) === idx;
    });
  }

  function itemMatchesProductOrCollection(item, productIds, collectionIds, collectionsByProductId) {
    var itemProductId = normalizeEntityId(item.product_id);
    if (productIds.length > 0 && productIds.indexOf(itemProductId) !== -1) return true;
    if (collectionIds.length > 0) {
      var itemCollections = collectionsByProductId[item.product_id] || collectionsByProductId[String(item.product_id)] || [];
      if (collectionIds.some(function (collectionId) {
        return itemCollections.indexOf(collectionId) !== -1;
      })) {
        return true;
      }
    }
    return false;
  }

  function cartMatchesProductConditions(items, conditions, collectionsByProductId) {
    var productIds = getConditionProductIds(conditions);
    var collectionIds = getConditionCollectionIds(conditions);
    if (productIds.length === 0 && collectionIds.length === 0) return true;
    var match = conditions.productMatch === 'all' ? 'all' : 'any';
    if (match === 'any') {
      return items.some(function (item) {
        return itemMatchesProductOrCollection(item, productIds, collectionIds, collectionsByProductId);
      });
    }
    return items.every(function (item) {
      return itemMatchesProductOrCollection(item, productIds, collectionIds, collectionsByProductId);
    });
  }

  function cartMatchesTagConditions(items, conditions, tagsByProductId) {
    var includeTags = normalizeTags(conditions.productTags || []);
    var excludeTags = normalizeTags(conditions.excludeProductTags || []);
    var requireAnyTags = normalizeTags(conditions.requireAnyProductTags || []);

    if (includeTags.length > 0) {
      var match = conditions.match === 'any' ? 'any' : 'all';
      if (match === 'any') {
        if (!items.some(function (item) {
          return itemHasAnyTag(item, includeTags, tagsByProductId);
        })) return false;
      } else if (!items.every(function (item) {
        return itemHasAnyTag(item, includeTags, tagsByProductId);
      })) {
        return false;
      }
    }

    if (requireAnyTags.length > 0) {
      if (!items.some(function (item) {
        return itemHasAnyTag(item, requireAnyTags, tagsByProductId);
      })) return false;
    }

    if (excludeTags.length > 0) {
      if (items.some(function (item) {
        return itemHasAnyTag(item, excludeTags, tagsByProductId);
      })) return false;
    }

    return true;
  }

  function ruleMatches(rule, context) {
    if (!rule.enabled) return false;
    var items = context.items;
    var subtotal = context.subtotal;
    var tagsByProductId = context.tagsByProductId;
    var collectionsByProductId = context.collectionsByProductId;
    var montage = context.montage;
    var conditions = rule.conditions || {};

    if (conditions.minSubtotal != null && subtotal < conditions.minSubtotal) return false;
    if (conditions.maxSubtotal != null && subtotal > conditions.maxSubtotal) return false;
    if (conditions.requireMontageFee && !montage.hasMontage) return false;
    if (conditions.excludeMontageFee && montage.hasMontage) return false;
    if (!cartMatchesTagConditions(items, conditions, tagsByProductId)) return false;
    if (!cartMatchesProductConditions(items, conditions, collectionsByProductId)) return false;
    return true;
  }

  function calculateRulePrice(rule, context) {
    var subtotal = context.subtotal;
    var numericPrice = Number(rule.price);
    switch (rule.priceType) {
      case 'free':
        return Number.isFinite(numericPrice) && numericPrice > 0 ? numericPrice : 0;
      case 'fixed':
        return Number.isFinite(numericPrice) ? numericPrice : 0;
      case 'tiered':
        return getTierPrice(rule.tiers, subtotal);
      default:
        return null;
    }
  }

  function evaluateShippingRules(config, destinationCountry, items, productData, subtotal) {
    var tagsByProductId = productData.tagsByProductId || {};
    var collectionsByProductId = productData.collectionsByProductId || {};
    var zone = findZoneForCountry(config, destinationCountry);
    if (!zone) return [];

    var context = {
      items: items,
      subtotal: subtotal,
      tagsByProductId: tagsByProductId,
      collectionsByProductId: collectionsByProductId,
      montage: { hasMontage: false, total: 0 }
    };

    var rules = (zone.rules || []).slice().sort(function (a, b) {
      return (a.priority != null ? a.priority : 99) - (b.priority != null ? b.priority : 99);
    });
    var matched = [];
    var seenCodes = {};

    rules.forEach(function (rule) {
      if (!ruleMatches(rule, context)) return;
      var price = calculateRulePrice(rule, context);
      if (price == null) return;
      var serviceCode = rule.serviceCode || rule.id;
      if (seenCodes[serviceCode]) return;
      seenCodes[serviceCode] = true;
      matched.push({ rule: rule, price: price });
    });

    var exclusiveMatches = matched.filter(function (entry) {
      return entry.rule.conditions && entry.rule.conditions.shippingMode === 'exclusive';
    });
    if (exclusiveMatches.length > 0) return exclusiveMatches;

    return matched;
  }

  function buildProductData(items) {
    var tagsByProductId = {};
    var collectionsByProductId = {};
    (items || []).forEach(function (item) {
      tagsByProductId[item.product_id] = (item.tags || []).map(function (t) {
        return String(t).toLowerCase();
      });
      collectionsByProductId[item.product_id] = (item.collection_ids || []).map(normalizeEntityId);
    });
    return { tagsByProductId: tagsByProductId, collectionsByProductId: collectionsByProductId };
  }

  function eurosToCents(euros) {
    if (euros == null || Number.isNaN(euros)) return null;
    return Math.round(Number(euros) * 100);
  }

  function getStandardShippingCents(config, countryCode, items, subtotalCents) {
    if (!config || !items || !items.length) return null;
    var code = normalizeCountryCode(countryCode);
    var subtotal =
      Number.isFinite(subtotalCents) && subtotalCents >= 0
        ? subtotalCents / 100
        : items.reduce(function (sum, it) {
            return sum + (it.line_price_cents || 0) / 100;
          }, 0);
    var rates = evaluateShippingRules(config, code, items, buildProductData(items), subtotal);
    var standard = rates.filter(function (entry) {
      return entry.rule.priceType !== 'montage';
    });
    if (standard.length === 0) return null;
    return eurosToCents(standard[0].price);
  }

  function formatTransportCents(cents) {
    if (cents == null) return 'Berekend bij afrekenen';
    if (cents <= 0) return 'Gratis';
    return (cents / 100).toFixed(2).replace('.', ',');
  }

  function formatTotalCents(cents) {
    var formatted = (cents / 100).toFixed(2).replace('.', ',');
    if (formatted.endsWith(',00')) {
      formatted = formatted.slice(0, -3);
    }
    return formatted;
  }

  function readPageData() {
    var el = document.getElementById('cart-shipping-estimate-data');
    if (!el) return null;
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      return null;
    }
  }

  function productsFromItems(items) {
    var map = {};
    (items || []).forEach(function (item) {
      map[item.product_id] = {
        tags: item.tags || [],
        collection_ids: item.collection_ids || [],
        handle: item.handle || ''
      };
    });
    return map;
  }

  function getState() {
    if (!window.MHO_SHIPPING) {
      var data = readPageData();
      window.MHO_SHIPPING = {
        shop: data && data.shop,
        estimate_url: data && data.estimate_url,
        country: (data && data.country) || 'NL',
        config: parseShippingConfig(data && data.config),
        products: productsFromItems(data && data.items)
      };
    }
    return window.MHO_SHIPPING;
  }

  function buildItemsFromCart(cart) {
    var state = getState();
    var products = state.products || {};
    return (cart.items || []).map(function (item) {
      var meta = products[item.product_id] || products[String(item.product_id)] || {};
      return {
        product_id: item.product_id,
        quantity: item.quantity,
        line_price_cents: item.final_line_price,
        name: item.product_title || item.title || '',
        sku: item.sku || '',
        handle: item.handle,
        tags: meta.tags || [],
        collection_ids: meta.collection_ids || []
      };
    });
  }

  function getShippingCentsForCart(cart) {
    if (!cart || !cart.items || !cart.items.length) return null;
    var state = getState();
    return getStandardShippingCents(
      state.config,
      state.country,
      buildItemsFromCart(cart),
      cart.total_price
    );
  }

  function applyTransportDisplay(shippingCents) {
    var el = document.querySelector('[data-cart-transport-value]');
    if (!el) return;
    el.textContent = formatTransportCents(shippingCents);
    if (shippingCents == null) {
      el.setAttribute('data-shipping-found', 'false');
      el.setAttribute('data-shipping-cents', '');
    } else {
      el.setAttribute('data-shipping-found', 'true');
      el.setAttribute('data-shipping-cents', String(shippingCents));
    }
  }

  function ensureProductMeta(cart) {
    var state = getState();
    if (!state.products) state.products = {};
    var missing = (cart.items || []).filter(function (item) {
      return !state.products[item.product_id] && !state.products[String(item.product_id)];
    });
    if (!missing.length) return Promise.resolve(false);

    return Promise.all(
      missing.map(function (item) {
        if (!item.handle) {
          state.products[item.product_id] = { tags: [], collection_ids: [] };
          return Promise.resolve();
        }
        return fetch('/products/' + item.handle + '.js')
          .then(function (response) {
            if (!response.ok) throw new Error('product js ' + response.status);
            return response.json();
          })
          .then(function (product) {
            state.products[product.id || item.product_id] = {
              tags: product.tags || [],
              collection_ids: [],
              handle: product.handle
            };
          })
          .catch(function () {
            state.products[item.product_id] = { tags: [], collection_ids: [] };
          });
      })
    ).then(function () {
      return true;
    });
  }

  function fetchAppEstimate(cart) {
    var state = getState();
    if (!state.estimate_url || !state.shop) {
      return Promise.reject(new Error('missing estimate endpoint'));
    }
    var items = buildItemsFromCart(cart);
    return fetch(state.estimate_url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        shop: state.shop,
        country: state.country || 'NL',
        subtotal_cents: cart.total_price,
        items: items
      })
    })
      .then(function (response) {
        if (!response.ok) throw new Error('estimate http ' + response.status);
        return response.json();
      })
      .then(function (result) {
        if (result == null || typeof result.price !== 'number') {
          throw new Error('invalid estimate');
        }
        return eurosToCents(result.price);
      });
  }

  window.MhoShipping = {
    getState: getState,
    getShippingCentsForCart: getShippingCentsForCart,
    applyTransportDisplay: applyTransportDisplay,
    formatTransportCents: formatTransportCents,
    formatTotalCents: formatTotalCents,
    ensureProductMeta: ensureProductMeta,
    fetchAppEstimate: fetchAppEstimate
  };
})(window);
